export enum SearchResultsSortOrder {
  Popularity = 'popularity',
  Recency = 'recency',
}

export default { SearchResultsSortOrder }
